export default "__VITE_ASSET__Lb_ykOYJ__"